function useEmployeePerformanceSkill() {
  return {};
}

export default useEmployeePerformanceSkill;
